module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_0.80f04b3c.png";